const state = {
    categoriesAddModal: false,
    snackbarShow: false,
    snackbarText: "",
    snackbarColor: "success",
    logged: null,
    isLoginFormModal: false,
    settings : {},
    isHomePageScrollToOrder : false,
    isNavigationDrawer : true
};

const getters = {
    categoriesAddModal: state => {
        return state.categoriesAddModal;
    },
    snackbarShow: state => {
        return state.snackbarShow;
    },
    snackbarText: state => {
        return state.snackbarText;
    },
    snackbarColor: state => {
        return state.snackbarColor;
    },
    logged: state => {
        return state.logged;
    },
    isLoggedIn: state => {
        return state.logged && state.logged.token && state.logged.user;
    },
    isLoginFormModal: state => {
        return state.isLoginFormModal;
    },
    settings: state => {
        return state.settings;
    }
};

const mutations = {
    categoriesAddModal(state, isDisplay) {
        state.categoriesAddModal = isDisplay;
    },
    snackbarShow(state, isDisplay) {
        state.snackbarShow = isDisplay;
    },
    snackbarText(state, text) {
        state.snackbarText = text;
    },
    snackbarColor(state, color) {
        state.snackbarColor = color;
    },
    setLogged(state, data) {
        state.logged = data;
    },
    setIsLoginFormModal(state, data) {
        state.isLoginFormModal = data;
    },
    setSettings(state, data) {
        state.settings = data;
    },
    setIsHomePageScrollToOrder(state, isScroll) {
        state.isHomePageScrollToOrder = isScroll;
    },
    setIsNavigationDrawer(state, isNavigationDrawer) {
        state.isNavigationDrawer = isNavigationDrawer;
    }
};

const actions = {
    showLoginModal({ commit, state }) {
        commit("setIsLoginFormModal", true);
    },
    logOut({ commit, state }) {
        commit("setLogged", {});
    },
    toggleNavigationDrawer({ commit, state }) {
        commit("setIsNavigationDrawer", !state.isNavigationDrawer);
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};